import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import { TopicCollectionHeader } from "scmp-app/components/topic-collection/topic-collection-header";
import { TopContentsContainer } from "scmp-app/components/topic/topic-top-contents/styles";

export const borderStyle = () => css`
  border-block-start: 1px solid rgba(0, 0, 0, 0.2);

  padding-block-start: 20px;

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 32px;
  }
`;

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: stretch;

  inline-size: 100%;
`;

export const ContentContainer = styled.div`
  inline-size: 100%;
  max-inline-size: 1024px;
  margin-inline: auto;

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 1208px;
    padding-inline: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid:
    "hero-contents" min-content
    "ads-1" min-content
    "rhs-module-1" min-content
    "." 32px
    "top-contents-1" min-content
    "top-contents-2" min-content
    "rhs-module-2" min-content
    "." 32px
    "ads-2" min-content
    "top-contents-3" min-content
    "top-contents-4" min-content
    "subscription-message" min-content
    "top-contents-5" min-content
    "rhs-module-3" min-content
    "ads-3" min-content
    "top-contents-6" min-content
    "top-contents-7" min-content
    "ads-4" min-content
    / minmax(0, 1fr);

  ${theme.breakpoints.up("desktop")} {
    grid:
      "hero-contents ads-1" min-content
      "hero-contents rhs-module-1" min-content
      "top-contents-1 rhs-module-1" min-content
      "top-contents-2 rhs-module-2" min-content
      "top-contents-3 rhs-module-2" min-content
      "top-contents-3 ." 32px
      "top-contents-3 ads-2" min-content
      "top-contents-4 ads-2" min-content
      "subscription-message ." min-content
      "top-contents-5 ads-3" min-content
      "top-contents-6 rhs-module-3" min-content
      "top-contents-6 ." min-content
      "top-contents-7 ads-4" min-content
      / minmax(0, 1fr) minmax(0, 300px);
    column-gap: 40px;
  }
`;

export const StyledTopicCollectionHeader = styled(TopicCollectionHeader)`
  margin-block: 20px;

  ${theme.breakpoints.up("desktop")} {
    margin-block: 32px;
  }
`;

export const HeroContents = styled.div`
  grid-area: hero-contents;

  margin-block-end: 32px;

  ${theme.breakpoints.up("tablet")} {
    padding-block-end: 24px;

    border-block-end: 1px solid rgba(0, 0, 0, 0.2);
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 32px;
    padding-block-end: 0;
    border-block-end: none;
  }
`;

export const TopContents1 = styled.div`
  grid-area: top-contents-1;

  ${borderStyle};
  ${theme.breakpoints.up("tablet")} {
    border-block-start: none;

    padding-block-start: 0;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 32px;
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);
  }
`;

export const TopContents2 = styled.div`
  grid-area: top-contents-2;

  ${borderStyle}

  ${TopContentsContainer} {
    padding-block-end: 32px;
  }
`;

export const TopContents3 = styled.div`
  grid-area: top-contents-3;

  ${borderStyle}

  ${theme.breakpoints.up("desktop")} {
    border-block-start: 1px solid rgba(0, 0, 0, 0.2);

    padding-block-start: 32px;
  }
`;

export const TopContents4 = styled.div`
  grid-area: top-contents-4;

  ${borderStyle}

  ${TopContentsContainer} {
    padding-block-end: 32px;
  }
`;

export const TopContents5 = styled.div`
  grid-area: top-contents-5;

  ${borderStyle}
`;

export const TopContents6 = styled.div`
  grid-area: top-contents-6;

  ${borderStyle}
`;

export const TopContents7 = styled.div`
  grid-area: top-contents-7;

  ${borderStyle}
`;

export const SubscriptionMessage = styled.div`
  grid-area: subscription-message;

  margin-block-end: 32px;
  ${theme.breakpoints.up("desktop")} {
    margin-block: 16px 48px;
  }
`;

export const Ads1 = styled.div`
  grid-area: ads-1;

  margin-block-end: 32px;
`;

export const Ads2 = styled.div`
  grid-area: ads-2;

  max-block-size: 630px;
  margin-block-end: 32px;
`;

export const Ads3 = styled.div`
  grid-area: ads-3;

  margin-block-end: 32px;
`;

export const Ads4 = styled.div`
  grid-area: ads-4;

  margin-block-end: 32px;
`;

export const RestContentWrapper = styled.div``;

export const StyledLoading = styled(Loading)`
  padding-block: 60px;
`;

export const RHSModule1 = styled.div`
  grid-area: rhs-module-1;
`;

export const RHSModule2 = styled.div`
  grid-area: rhs-module-2;
`;

export const RHSModule3 = styled.div`
  grid-area: rhs-module-3;
`;
